module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"NavBar":{"logout":"Logout"}},"es":{"NavBar":{"logout":"Salir"}}}')
  delete Component.options._Ctor
}
